import { html, render } from 'lit-html'

export const template = html`
<advisory-message
  icon=restart
  spinIcon=true
  subject="Awaiting login"
  message="Please complete login in the window. If you don't see it, check the popup wasn't blocked by your browser."
  abortLabel="Restart"
  @abort=${() => window.location.reload()}
></advisory-message>
`

export default function () {
  render(template, this.el, {
    eventContext: this
  })
}
